import React, {useEffect, useState} from 'react';
import {IsT} from "my-styles/media/media";
import {categoryViewModel} from "../../../viewModels/Category.viewModel";
import {groupedList} from "components/utils/ListUtility";
import IconTitleButton from "components/buttons/IconTitleButton";
import {useHistory} from "react-router-dom";

export default function GridCategory(props) {

    const history = useHistory()

    const [isCancelled, setIsCancelled] = useState(false)
    const [categories, setCategories] = useState([])

    const onCategorySelect = (category) => {
        props.onNavigate(history, "/category?c=" + category.childs[0].id + "&p=1")
    }

    useEffect(() => {
        categoryViewModel.categoryList.subscribe((categories) => {
            if (isCancelled) return

            let constLimit = IsT() ? 4 : 2
            let emptyCount = constLimit - (categories.length % constLimit)
            setCategories(groupedList(categories, constLimit, emptyCount))
        })
        return () => {
            setIsCancelled(true)
        }
    }, [isCancelled])

    return (<div className="center" style={{paddingTop: "1em"}}>
        {categories.map((categoryGroup, index) => {
            return (<div key={index} style={{width: "97%"}}
                         className="horizontalFullScreen marginTopBottomSmall center">
                {categoryGroup.map((category, index1) => {
                    return <div key={index1} style={{opacity: category.isTemp ? 0 : 1}}
                                className="card full marginRightSmall">
                        <IconTitleButton
                            width={"100%"}
                            fontSize="mediumTextBold"
                            isvertical={true.toString()}
                            icon={<img className="xxxLargeIcon" src={category.image} alt=""/>}
                            title={category.title}
                            onClick={() => {
                                if (!category.isTemp) {
                                    onCategorySelect(category)
                                }
                            }}/>
                    </div>

                })}
            </div>)
        })}
    </div>)
}